import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const useEndCallGracePeriodEnabled = (): boolean => {
  return useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.END_CALL_GRACE_PERIOD);
};
